import React from 'react';
import { FormikProvider, useFormik } from 'formik';

import * as Yup from 'yup';
import { InputFormField } from '../../../../../components/formFields/InputFormField';

const ValidationSchema = Yup.object().shape({
  ico: Yup.string()
    .matches(/^\d{8}$/, 'IČO musí mít přesně 8 číslic')
    .required('Povinné pole'),
});

interface CinFormProps {
  onSubmit: (values: any) => void;
}

const CinForm = ({ onSubmit }: CinFormProps) => {
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: ValidationSchema,
    initialValues: { ico: '' },
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  return (
    <FormikProvider value={formik}>
      <form
        id="cin-form"
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
      >
        <InputFormField
          name="ico"
          value={formik.values.ico}
          label="IČO"
          placeholder="IČO"
          data-testid="cin-form-ico-input"
          {...formik}
        />
      </form>
    </FormikProvider>
  );
};

export default CinForm;
